var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pattern-mask",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "50%",
    fy: "50%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#400052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a400ff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "qrmask"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,64) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,64) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,64) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,96) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,96) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,96) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,128) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,128) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,128) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,128) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,160) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,192) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,192) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,224) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,224) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,224) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,224) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,256) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,256) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,256) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,288) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,288) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,288) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704,320) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704,352) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,384) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,416) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,448) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(608,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704,480) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,512) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,512) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,544) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,544) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(608,544) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(704,544) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,576) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,608) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(608,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,640) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,672) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(608,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,704) scale(5.4933333333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14V4.4C14,2,12,0,9.6,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.4,14H14z M4.8,2h4.4C10.7,2,12,3.3,12,4.8V12H4.8 C3.3,12,2,10.7,2,9.2V4.8C2,3.3,3.3,2,4.8,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16) rotate(90 7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14V4.4C14,2,12,0,9.6,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.4,14H14z M4.8,2h4.4C10.7,2,12,3.3,12,4.8V12H4.8 C3.3,12,2,10.7,2,9.2V4.8C2,3.3,3.3,2,4.8,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,512)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16) rotate(-90 7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14V4.4C14,2,12,0,9.6,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.4,14H14z M4.8,2h4.4C10.7,2,12,3.3,12,4.8V12H4.8 C3.3,12,2,10.7,2,9.2V4.8C2,3.3,3.3,2,4.8,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3v0c0-1.7,1.3-3,3-3h0c1.7,0,3,1.3,3,3V6z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16) rotate(90 3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3v0c0-1.7,1.3-3,3-3h0c1.7,0,3,1.3,3,3V6z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,576)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(16) rotate(-90 3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,6H3C1.3,6,0,4.7,0,3v0c0-1.7,1.3-3,3-3h0c1.7,0,3,1.3,3,3V6z"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    mask: "url(#qrmask)",
    fill: "url(#pattern-mask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0aec91560fded3acabbb8c4c37e25ebd.svg";
export { ForwardRef as ReactComponent };